import React, { useId } from 'react';
import { usePropState } from '@anton.bobrov/react-hooks';
import { ExpandContent as ExpandContent$1 } from '@anton.bobrov/react-components';
import cx from 'classnames';
import styles from './index.module.scss.js';

const ExpandContent = ({
  className,
  style,
  thumbText,
  thumbTextClose = thumbText,
  isActive: isActiveProp = false,
  hasAlpha = false,
  duration = 350,
  id: idProp,
  children
}) => {
  const generatedId = useId();
  const id = idProp || generatedId;
  const [isActive, setIsActive] = usePropState(isActiveProp);
  return /* @__PURE__ */ React.createElement("div", { className: cx(styles.box, className), style }, /* @__PURE__ */ React.createElement(
    ExpandContent$1,
    {
      isActive,
      hasAlpha,
      duration
    },
    /* @__PURE__ */ React.createElement("div", { id, "aria-hidden": !isActive }, children)
  ), thumbText && /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      onClick: () => setIsActive(!isActive),
      className: cx(styles.thumb, {
        [styles.active]: isActive
      }),
      "aria-expanded": isActive,
      "aria-controls": id
    },
    /* @__PURE__ */ React.createElement(
      "svg",
      {
        width: "6",
        height: "5",
        viewBox: "0 0 6 5",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      /* @__PURE__ */ React.createElement(
        "path",
        {
          d: "M0.700826 0.5L5.29944 0.5C5.59895 0.5 5.7776 0.796715 5.61146 1.01823L3.31215 4.08397C3.16371 4.28189 2.83655 4.28189 2.68811 4.08397L0.388807 1.01823C0.222668 0.796715 0.401315 0.5 0.700826 0.5Z",
          fill: "currentColor"
        }
      )
    ),
    isActive ? thumbTextClose : thumbText
  ));
};

export { ExpandContent };
//# sourceMappingURL=index.js.map
